import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { Plane, Upload, Mail, Paperclip, Trash2 } from "lucide-react";
import { toast } from "react-toastify";
import axios from "axios";

const API_BASE_URL = `${process.env.REACT_APP_API_URL?.replace(/\/$/, "") || ""}/api`;

const EditTravelDialog = ({ isOpen, onClose, travelData, fetchData, users }) => {
  console.log("travelData", travelData)
  const [loading, setLoading] = useState(false);
  const [travelDetails, setTravelDetails] = useState({
    address: "",
    startTime: "08:00",
    endTime: "18:00",
    description: "",
    additionalNotes: "",
    requiredItems: "",
  });
  const [attachments, setAttachments] = useState({
    ferry: null,
    flight: null
  });

  useEffect(() => {
    if (isOpen && travelData) {
      const startDate = new Date(travelData.start_date || travelData.planned_date_start);
      const endDate = new Date(travelData.end_date || travelData.planned_date_end);
      setTravelDetails({
        address: travelData.address || "",
        startTime: startDate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false }),
        endTime: endDate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false }),
        description: travelData.description || "",
        additionalNotes: "",
        requiredItems: travelData.required_items || "",
      });
    }
  }, [isOpen, travelData]);

  const handleFileUpload = (type) => (event) => {
    const file = event.target.files[0];
    if (file) {
      setAttachments(prev => ({ ...prev, [type]: file }));
    }
  };

  const handleResendEmail = async () => {
    try {
      const token = localStorage.getItem("access_token");
      const travelId = travelData.id.replace("travel-", "");
      
      console.log("Resend email - travelData:", travelData);
      console.log("Resend email - users list:", users);
      console.log("Resend email - looking for user_id:", travelData.user_id, "or userId:", travelData.userId);
      
      // Find user data - try by user_id or userId property
      let userData = users?.find(u => u.id === travelData.user_id || u.id === travelData.userId) || 
                     users?.find(u => u.username === travelData.userId);
      
      // If users list is not available, fetch user data from API
      if (!userData && (travelData.user_id || travelData.userId)) {
        try {
          const userIdToFetch = travelData.user_id || travelData.userId;
          console.log("Fetching user from API with id:", userIdToFetch);
          const userResponse = await axios.get(`${API_BASE_URL}/users/${userIdToFetch}/`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          userData = userResponse.data;
          console.log("Fetched user data from API:", userData);
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      }
      
      if (!userData) {
        toast.error("User not found - check console for details");
        console.error("User not found. TravelData:", travelData, "Users:", users);
        return;
      }

      // Get the updated travel data first if attachments were added
      let updatedTravelId = travelId;
      if (attachments.ferry || attachments.flight) {
        // Wait a moment for the update to complete
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        // Fetch the updated travel data
        try {
          const travelResponse = await axios.get(`${API_BASE_URL}/travel/${travelId}/`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          console.log("Updated travel data after attachment:", travelResponse.data);
        } catch (error) {
          console.error("Error fetching updated travel:", error);
        }
      }
      
      // Use the original send_travel_email endpoint with full travel details
      const emailData = {
        user_email: userData.email,
        user_name: `${userData.first_name} ${userData.last_name}`,
        travel_id: updatedTravelId,
        travel_data: {
          trainingName: "Travel Information Update",
          address: travelDetails.address || travelData.address,
          date: new Date(travelData.start_date).toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }),
          travelDate: new Date(travelData.start_date).toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }),
          startTime: travelDetails.startTime || new Date(travelData.start_date).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false }),
          endTime: travelDetails.endTime || new Date(travelData.end_date).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false }),
          description: (travelDetails.description || travelData.description || "") + 
                      (travelDetails.additionalNotes ? `\n\nAdditional Information:\n${travelDetails.additionalNotes}` : ''),
          required_items: travelDetails.requiredItems || travelData.required_items || ""
        }
      };

      console.log("Sending resend email with data:", emailData);
      const response = await axios.post(`${API_BASE_URL}/travel/send_travel_email/`, emailData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log("Email API response:", response.data);

      toast.success("Email resent successfully");
      
      // Wait a moment for backend to update the email_sent flag
      setTimeout(() => {
        fetchData();
      }, 500);
    } catch (error) {
      console.error("Error resending email:", error);
      toast.error("Failed to resend email");
    }
  };

  const handleDeleteTravel = async () => {
    if (!window.confirm("Are you sure you want to delete this travel? An email will be sent to the user notifying them of the cancellation.")) {
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem("access_token");
      if (!token) {
        toast.error("Authorization token not found. Please login again.");
        return;
      }
      console.log("Token found:", token ? "Yes" : "No");
      const travelId = travelData.id.replace("travel-", "");
      
      // Find user data
      console.log("Looking for user with user_id:", travelData.user_id, "or userId:", travelData.userId);
      console.log("Available users:", users);
      let userData = users?.find(u => u.id === travelData.user_id || u.id === travelData.userId) || 
                     users?.find(u => u.username === travelData.userId);
      
      // If users list is not available, fetch user data from API
      if (!userData && (travelData.user_id || travelData.userId)) {
        try {
          const userIdToFetch = travelData.user_id || travelData.userId;
          const userResponse = await axios.get(`${API_BASE_URL}/users/${userIdToFetch}/`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          userData = userResponse.data;
          console.log("Fetched user data from API:", userData);
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      }
      
      console.log("Found user data:", userData);
      
      if (userData) {
        // Send cancellation email
        const travelDateFormatted = new Date(travelData.start_date).toLocaleDateString('en-US', { 
          weekday: 'long', 
          year: 'numeric', 
          month: 'long', 
          day: 'numeric' 
        });
        
        const emailData = {
          user_email: userData.email,
          user_name: `${userData.first_name} ${userData.last_name}`,
          travel_date: travelDateFormatted
        };

        try {
          console.log("Sending cancellation email with data:", emailData);
          await axios.post(`${API_BASE_URL}/travel/send_cancellation_email/`, emailData, {
            headers: { Authorization: `Bearer ${token}` },
          });
          console.log("Cancellation email sent successfully");
        } catch (emailError) {
          console.error("Error sending cancellation email:", emailError);
          console.error("Email data was:", emailData);
          // Continue with deletion even if email fails
        }
      }

      // Delete the travel
      await axios.delete(
        `${API_BASE_URL}/travel/${travelId}/`,
        {
          headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
        }
      );

      toast.success("Travel deleted and cancellation email sent");
      onClose();
      fetchData();
    } catch (error) {
      console.error("Error deleting travel:", error);
      toast.error("Failed to delete travel");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateTravel = async () => {
    if (!travelData || !travelData.id) {
      toast.error("Missing travel data for update");
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem("access_token");
      const baseDate = new Date(travelData.start_date || travelData.planned_date_start);
      const datePart = baseDate.toISOString().split("T")[0];
      const [startHours, startMinutes] = travelDetails.startTime.split(":");
      const [endHours, endMinutes] = travelDetails.endTime.split(":");
      const startDate = new Date(`${datePart}T${startHours}:${startMinutes}:00`);
      const endDate = new Date(`${datePart}T${endHours}:${endMinutes}:00`);
      const travelId = travelData.id.replace("travel-", "");
      
      // Find user data for email notification
      console.log("Update: Looking for user with user_id:", travelData.user_id, "or userId:", travelData.userId);
      console.log("Update: Available users:", users);
      let userData = users?.find(u => u.id === travelData.user_id || u.id === travelData.userId) || 
                     users?.find(u => u.username === travelData.userId);
      
      // If users list is not available, fetch user data from API
      if (!userData && (travelData.user_id || travelData.userId)) {
        try {
          const userIdToFetch = travelData.user_id || travelData.userId;
          const userResponse = await axios.get(`${API_BASE_URL}/users/${userIdToFetch}/`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          userData = userResponse.data;
          console.log("Update: Fetched user data from API:", userData);
        } catch (error) {
          console.error("Update: Error fetching user data:", error);
        }
      }
      
      console.log("Update: Found user data:", userData);

      const formData = new FormData();
      formData.append('start_date', startDate.toISOString());
      formData.append('end_date', endDate.toISOString());
      formData.append('address', travelDetails.address);
      formData.append('description', travelDetails.description + (travelDetails.additionalNotes ? `\n\nAdditional Information:\n${travelDetails.additionalNotes}` : ''));
      formData.append('required_items', travelDetails.requiredItems || '');
      
      if (attachments.ferry) {
        formData.append('attachment_ferry', attachments.ferry);
      }
      if (attachments.flight) {
        formData.append('attachment_flight', attachments.flight);
      };

      const updateResponse = await axios.patch(
        `${API_BASE_URL}/travel/${travelId}/`,
        formData,
        {
          headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          },
        }
      );

      console.log("Travel updated successfully:", updateResponse.data);

      // Send update notification email if attachments were added or notes changed
      if ((attachments.ferry || attachments.flight || travelDetails.additionalNotes) && userData) {
        // Wait a moment for files to be saved
        await new Promise(resolve => setTimeout(resolve, 500));
        
        // Use the send_travel_email endpoint with attachments
        const emailData = {
          user_email: userData.email,
          user_name: `${userData.first_name} ${userData.last_name}`,
          travel_id: travelId,
          travel_data: {
            trainingName: "Travel Information Update",
            address: travelDetails.address || travelData.address,
            date: new Date(travelData.start_date).toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }),
            travelDate: new Date(travelData.start_date).toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }),
            startTime: travelDetails.startTime,
            endTime: travelDetails.endTime,
            description: (travelDetails.description || travelData.description || "") + 
                        (travelDetails.additionalNotes ? `\n\nAdditional Information:\n${travelDetails.additionalNotes}` : '') +
                        (attachments.ferry ? '\n\n✓ Ferry ticket attached' : '') +
                        (attachments.flight ? '\n✓ Flight ticket attached' : ''),
            required_items: travelDetails.requiredItems || travelData.required_items || ""
          }
        };

        try {
          await axios.post(`${API_BASE_URL}/travel/send_travel_email/`, emailData, {
            headers: { Authorization: `Bearer ${token}` },
          });
          toast.success("Travel updated and email sent with attachments");
        } catch (emailError) {
          console.error("Error sending update email:", emailError);
          toast.success("Travel updated successfully");
        }
      } else {
        toast.success("Travel updated successfully");
      }
      
      onClose();
      fetchData();
    } catch (error) {
      console.error("Error updating travel:", error);
      toast.error("Failed to update travel");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle className="flex items-center">
            <Plane className="h-5 w-5 mr-2 text-green-600" />
            <span>Edit Travel</span>
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 my-4">
          <div>
            <label className="block text-sm text-gray-700 mb-1">Destination Address</label>
            <textarea
              className="w-full p-2 text-sm border rounded"
              value={travelDetails.address}
              onChange={(e) => setTravelDetails((prev) => ({ ...prev, address: e.target.value }))}
              placeholder="Enter destination address"
              rows={2}
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm text-gray-700 mb-1">Start Time</label>
              <input
                type="time"
                className="w-full p-2 text-sm border rounded"
                value={travelDetails.startTime}
                onChange={(e) => setTravelDetails((prev) => ({ ...prev, startTime: e.target.value }))}
              />
            </div>
            <div>
              <label className="block text-sm text-gray-700 mb-1">End Time</label>
              <input
                type="time"
                className="w-full p-2 text-sm border rounded"
                value={travelDetails.endTime}
                onChange={(e) => setTravelDetails((prev) => ({ ...prev, endTime: e.target.value }))}
              />
            </div>
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">Travel Description</label>
            <textarea
              className="w-full p-2 text-sm border rounded"
              value={travelDetails.description}
              onChange={(e) => setTravelDetails((prev) => ({ ...prev, description: e.target.value }))}
              placeholder="Enter travel description"
              rows={3}
            />
          </div>
          <div className="space-y-2">
            <label className="block text-sm text-gray-700 mb-1">Attachments</label>
            <div className="space-y-2">
              {/* Ferry Ticket */}
              <div>
                {travelData.attachment_ferry && !attachments.ferry && (
                  <div className="mb-2 p-2 bg-blue-50 rounded border border-blue-200">
                    <div className="flex items-center justify-between">
                      <a 
                        href={travelData.attachment_ferry} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-sm text-blue-600 hover:text-blue-800 flex items-center"
                      >
                        <Paperclip className="h-3 w-3 mr-1" />
                        Current Ferry Ticket (click to view)
                      </a>
                    </div>
                  </div>
                )}
                <div className="flex items-center space-x-2">
                  <label className="flex items-center space-x-2 cursor-pointer bg-gray-50 p-2 rounded border hover:bg-gray-100">
                    <Upload className="h-4 w-4" />
                    <span className="text-sm">{travelData.attachment_ferry ? 'Replace' : 'Upload'} Ferry Ticket</span>
                    <input
                      type="file"
                      className="hidden"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={handleFileUpload('ferry')}
                    />
                  </label>
                  {attachments.ferry && (
                    <span className="text-sm text-green-600 flex items-center">
                      <Paperclip className="h-3 w-3 mr-1" />
                      New: {attachments.ferry.name}
                    </span>
                  )}
                </div>
              </div>
              
              {/* Flight Ticket */}
              <div>
                {travelData.attachment_flight && !attachments.flight && (
                  <div className="mb-2 p-2 bg-blue-50 rounded border border-blue-200">
                    <div className="flex items-center justify-between">
                      <a 
                        href={travelData.attachment_flight} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-sm text-blue-600 hover:text-blue-800 flex items-center"
                      >
                        <Paperclip className="h-3 w-3 mr-1" />
                        Current Flight Ticket (click to view)
                      </a>
                    </div>
                  </div>
                )}
                <div className="flex items-center space-x-2">
                  <label className="flex items-center space-x-2 cursor-pointer bg-gray-50 p-2 rounded border hover:bg-gray-100">
                    <Upload className="h-4 w-4" />
                    <span className="text-sm">{travelData.attachment_flight ? 'Replace' : 'Upload'} Flight Ticket</span>
                    <input
                      type="file"
                      className="hidden"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={handleFileUpload('flight')}
                    />
                  </label>
                  {attachments.flight && (
                    <span className="text-sm text-green-600 flex items-center">
                      <Paperclip className="h-3 w-3 mr-1" />
                      New: {attachments.flight.name}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">Additional Notes / Attachment Information</label>
            <textarea
              className="w-full p-2 text-sm border rounded"
              value={travelDetails.additionalNotes}
              onChange={(e) => setTravelDetails((prev) => ({ ...prev, additionalNotes: e.target.value }))}
              placeholder="e.g., Ferry ticket attached, Flight confirmation number: ABC123"
              rows={2}
            />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">Required Items to Bring</label>
            <textarea
              className="w-full p-2 text-sm border rounded"
              value={travelDetails.requiredItems}
              onChange={(e) => setTravelDetails((prev) => ({ ...prev, requiredItems: e.target.value }))}
              placeholder="e.g., Safety boots, helmet, passport, certificates..."
              rows={2}
            />
          </div>
          {travelData && (
            <div className="flex items-center justify-between p-3 bg-blue-50 rounded">
              <div className="text-sm">
                {travelData.email_sent ? (
                  <span className="text-green-600 flex items-center">
                    <Mail className="h-4 w-4 mr-1" />
                    Email sent {travelData.email_sent_at ? new Date(travelData.email_sent_at).toLocaleDateString() : ''}
                  </span>
                ) : (
                  <span className="text-red-600 flex items-center">
                    <Mail className="h-4 w-4 mr-1" />
                    Email not sent
                  </span>
                )}
              </div>
              <Button
                size="sm"
                variant="outline"
                onClick={handleResendEmail}
                className="flex items-center space-x-1"
              >
                <Mail className="h-3 w-3" />
                <span>Resend Email</span>
              </Button>
            </div>
          )}
        </div>
        <DialogFooter className="flex justify-between">
          <Button
            variant="outline"
            onClick={handleDeleteTravel}
            disabled={loading}
            className="text-red-600 hover:bg-red-50 border-red-200"
          >
            <Trash2 className="h-4 w-4 mr-1" />
            Delete
          </Button>
          <div className="flex space-x-2">
            <Button variant="outline" onClick={onClose} disabled={loading}>
              Cancel
            </Button>
            <Button
              onClick={handleUpdateTravel}
              disabled={loading || !travelDetails.address}
              className="bg-green-600 hover:bg-green-700 text-white"
            >
              {loading ? "Updating..." : "Update Travel"}
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default EditTravelDialog;